export default {
    FPShowFilePicker: {
        name: 'FPShowFilePicker',
        options: { isCore: true, excludeFromKusto: true },
    },
};
